import React, { useState, useEffect } from "react";
import Slider_Panel from "./Slider_Panel";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";

interface SliderProps {
    images: string[];
}

const sliderTitle = "Bridging Mining & Blockchain Technology";
const sliderSubtitle = "Tokenizing Real-World Gold and Mineral Assets";

const sliderContexts = [
    "Mineralex Group is pioneering a groundbreaking tokenized platform that bridges real-world mineral resources and the digital economy, revolutionizing mineral exploration and extraction through blockchain-enabled operations.",
    "By combining the transparency and immutability of blockchain with the tangible backing of high-value assets—primarily gold, alongside coltan, rare earth elements, and tin—Mineralex offers two core tokens: The Utility Token to fund early-stage mines development, RWA token establishment and promotion. The Real-World Asset (RWA) Token directly collateralized initially by proved reserved value more than $10B followed by securely stored mined gold from Mineralex SL mines projects and M&A. Income from non-gold mineral mined further supports dividend distributions and continuous mineral extraction growth.",
    "This dual-token model facilitates transparent, fractional ownership and staking incentives, empowers local African communities, and creates a self-sustaining value-generating loop.",
    "Rapid consolidation and secure vaulting of mined gold reserves minimize volatility and enhance token stability, making Mineralex’s mining investment opportunities accessible, secure, and profitable for global investors.",
];

const Slider: React.FC<SliderProps> = ({ images }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    // Autoplay effect
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex(prevIndex => (prevIndex + 1) % images.length);
        }, 3000); // Slide every 5 seconds

        return () => clearInterval(interval);
    }, [images.length]);

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    };

    return (
        <div
            id="tokenization_slider"
            className="w-full flex flex-col justify-center xl:justify-start items-center gap-6 bg-[#172B6B] bg-[url('../public/home/section4.svg')] bg-cover bg-center p-4 xl:py-12 relative"
        >
            {/* <div className="w-full flex flex-row justify-center items-start gap-10">
                <div className="w-full md:w-2/3 h-auto relative">
                    <img
                        src={images[currentIndex]}
                        alt={`Slide ${currentIndex + 1}`}
                        className="w-full h-auto max-h-96 rounded-[26px]"
                    />
                    <div className="flex justify-center gap-3 mt-4">
                        {images.map((_, index) => (
                            <div
                                key={index}
                                className={`w-[5.82px] h-[5.82px] rounded-full cursor-pointer ${index === currentIndex ? "bg-[#3CCDB3]" : "bg-[#F8D835]"}`}
                                onClick={() => setCurrentIndex(index)}
                            ></div>
                        ))}
                    </div>

                    <button
                        className="absolute top-1/2 -left-0 transform -translate-y-1/2 w-12 h-12 bg-inherit text-[#3CCDB3] focus:outline-none flex justify-center items-center"
                        onClick={prevSlide}
                    >
                        <MdOutlineKeyboardArrowLeft className="text-4xl sm:text-6xl" />
                    </button>
                    <button
                        className="absolute top-1/2 -right-0 transform -translate-y-1/2 w-12 h-12 bg-inherit text-[#3CCDB3] focus:outline-none flex justify-center items-center"
                        onClick={nextSlide}
                    >
                        <MdOutlineKeyboardArrowRight className="text-4xl sm:text-6xl" />
                    </button>
                </div>
           
            </div> */}


            <div className="w-full max-w-5xl relative flex flex-row justify-center items-center">
                <Slider_Panel title={sliderTitle} subtitle={sliderSubtitle} contexts={sliderContexts} />
            </div>

        </div>
    );
};

export default Slider;
